// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"671b309a","590":"9b2df254","702":"be2bbe8f"}[chunkId] + ".chunk.js";
};